import { toRefs, computed } from 'vue';
import { useGroup } from '../../compositions/component-lib.esm17.js';

//
var script = {
  name: 'InputBtnGroup',
  props: {
    value: {
      type: [Array, Number, String],
      default: null
    },
    ariaLabel: {
      type: String,
      required: true
    },
    multiple: Boolean,
    /**
     * @type {'xs'|'sm'|'md'|'lg'}
     */
    size: {
      type: String,
      default: 'md'
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      value,
      multiple,
      size
    } = toRefs(props);
    useGroup(value, val => emit('input', val), {
      multiple,
      groupName: 'input-group',
      provideValues: {
        size
      }
    });
    const classes = computed(() => ({
      'input-btn-group--xs': props.size === 'xs',
      'input-btn-group--sm': props.size === 'sm',
      'input-btn-group--md': props.size === 'md',
      'input-btn-group--lg': props.size === 'lg'
    }));
    return {
      classes
    };
  }
};
export { script as default };